import {arrayToTree} from 'performant-array-to-tree';

export const flattenListToTreeList = (list) => {
  return arrayToTree(list, { dataField: null, id: 'id' })
};
